import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Link, Typography } from '@mui/material';
import cx from 'classnames';

import './Footer.scss';

const Footer = ({ fullscreen = false }) => {
    const { t } = useTranslation();

    const siteMapList = [
        {
            title: t('common.navbar.home.title'),
            link: '/'
        },
        {
            title: t('common.navbar.aboutUs.title'),
            link: '/about-us'
        },
        {
            title: t('common.navbar.advantage.title'),
            link: '/advantage'
        },
        {
            title: t('common.navbar.contactUs.title'),
            link: '/contact-us'
        },
        {
            title: t('common.navbar.privacyPolicy.title'),
            link: '/privacy-policy'
        },
        {
            title: t('common.navbar.amlPolicy.title'),
            link: '/aml-policy'
        },
        {
            title: t('common.navbar.antiFraudPolicy.title'),
            link: '/antifraud-policy'
        }
    ];

    return (
        <Box className={cx(['footer', { fullscreen }])}>
            <Box className="footerWrapper">
                <Box className="siteMap">
                    <Box className="logoWrapper">
                        <Box className="logo">
                            <img
                                src={
                                    process.env.PUBLIC_URL +
                                    process.env.REACT_APP_LOGO_PATH
                                }
                                alt="uEnjoy Logo"
                            />
                        </Box>
                        <Typography className="footerDesc">
                        {t('common.footer.desc')}
                        </Typography>
                    </Box>
                    <Box className="siteMapList">
                        {siteMapList.map((siteMap, index) => (
                            <Link
                                key={index}
                                href={siteMap.link}
                                underline="none">
                                <span>{siteMap.title}</span>
                            </Link>
                        ))}
                    </Box>
                </Box>
                <Box className="copyright">
                    <Typography>{t('common.footer.copyright')}</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Footer;
